const initialState = {
  resultsProductAccessibilityList: [],
  resultsProductAccessibility: {},
  resultsProductAccessibilityAdd: {},
  resultsProductAccessibilityPatch: {},
  resultsProductAccessibilityDelete: {},
  resultsAccessibilityProductAdd: {},
  resultsAccessibilityProductDelete: {},
  resultsProductsAccessibilityAdd: {},
  resultsProductsAccessibilityDelete: {},
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_PRODUCT_ACCESSIBILITY_RESPONSE_GET":
      newState.resultsProductAccessibilityList = action.value;
      break;
    case "PRODUCT_ACCESSIBILITY_RESPONSE_GET":
      newState.resultsProductAccessibility = action.value;
      break;
    case "PRODUCT_ACCESSIBILITY_RESPONSE_RESET":
      newState.resultsProductAccessibility = {};
      break;
    case "PRODUCT_ACCESSIBILITY_RESPONSE_ADD":
      newState.resultsProductAccessibilityAdd = action.value;
      break;
    case "PRODUCT_ACCESSIBILITY_RESPONSE_UPDATE":
      newState.resultsProductAccessibilityPatch = action.value;
      break;
    case "PRODUCT_ACCESSIBILITY_RESPONSE_DELETE":
      newState.resultsProductAccessibilityDelete = action.value;
      break;
    case "PRODUCTS_ACCESSIBILITY_RESPONSE_ADD":
      newState.resultsProductsAccessibilityAdd = action.value;
      break;
    case "PRODUCTS_ACCESSIBILITY_RESPONSE_DELETE":
      newState.resultsProductsAccessibilityDelete = action.value;
      break;
    case "ACCESSIBILITY_PRODUCT_RESPONSE_ADD":
      newState.resultsAccessibilityProductAdd = action.value;
      break;
    case "ACCESSIBILITY_PRODUCTS_RESPONSE_DELETE":
      newState.resultsAccessibilityProductDelete = action.value;
      break;
    case "RESET_ACCESSIBILITY_RESPONSES":
      newState.resultsProductAccessibilityAdd = {};
      newState.resultsProductAccessibilityPatch = {};
      newState.resultsProductAccessibilityDelete = {};
      newState.resultsProductsAccessibilityAdd = {};
      newState.resultsProductsAccessibilityDelete = {};
      newState.resultsAccessibilityProductAdd = {};
      newState.resultsAccessibilityProductDelete = {};
      break;
    default:
      break;
  }
  return newState;
};

export default reducer;
